export enum StepsEnum {
  COMPANY = 'company',
  PLAN = 'plan',
  LICENCES = 'licences',
  INTUNE = 'intune',
  REVIEW = 'review',
}

export enum OnboardingStatus {
  SESSION_CREATED = 'session_created',
  COMPANY_SAVED = 'company_saved',
  PLAN_SELECTED = 'plan_selected',
  PAYMENT_PENDING = 'payment_pending',
  PAYMENT_CONFIRMED = 'payment_confirmed',
  CONSENT_GRANTED = 'consent_granted',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
}
